import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import HeaderSecondary from '@components/HeaderSecondary';

import HealthQuoteForm from '@components/HealthQuoteForm';

const HealthQuotePage = () => {
  return (
    <>
      <HeaderSecondary />
      <Container className="mt-4">
        <Row className="justify-content-center">
          <Col md={8}>
            <HealthQuoteForm />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export { HealthQuotePage };
